import orderEdit from "./orderEdit";
import orderList from "./orderList";
import { Receipt,FiberManualRecord } from "@mui/icons-material";

const OrderCart = {
  list: orderList,
  edit: orderEdit,
  icon: Receipt,
  createIcon:FiberManualRecord
};
export default OrderCart;